import type { Product } from '@/storage/products'
import { ref } from 'vue'

export const productBus = ref<Product | null>(null)
